/**
 * Standard Color Handler
 * Handles color codes for standard product variants (non-custom colors)
 */

// Prevent duplicate initialization
if (typeof window.StandardColorHandler === 'undefined') {

class StandardColorHandler {
  constructor() {
    console.log('[STANDARD-COLOR] Handler initializing...');
    this.variantColorCodes = {};
    this.init();
  }

  init() {
    // Load variant color codes from metafields or data
    this.loadVariantColorCodes();
    
    // Create or find the color code input
    this.setupColorCodeInput();
    
    // Listen for variant changes
    this.listenForVariantChanges();
    
    // Check initial variant
    setTimeout(() => this.checkCurrentVariant(), 100);
  }

  loadVariantColorCodes() {
    // Try to get variant color codes from the custom color data if available
    const customColorData = window.customColorData;
    if (customColorData && customColorData.variantColorCodes) {
      this.variantColorCodes = customColorData.variantColorCodes;
      console.log('[STANDARD-COLOR] Loaded variant color codes from custom color data:', this.variantColorCodes);
      return;
    }

    // Try to get from variant metafields directly
    const variantElements = document.querySelectorAll('[data-variant-color-code]');
    variantElements.forEach(el => {
      const variantId = el.dataset.variantId;
      const colorCode = el.dataset.variantColorCode;
      if (variantId && colorCode) {
        this.variantColorCodes[variantId] = colorCode;
      }
    });
    
    if (Object.keys(this.variantColorCodes).length > 0) {
      console.log('[STANDARD-COLOR] Loaded variant color codes from data attributes:', this.variantColorCodes);
    }
  }

  setupColorCodeInput() {
    // Find the product form
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) {
      console.log('[STANDARD-COLOR] Product form not found');
      return;
    }

    // Create or find color code input - use same ID as custom-color-v2.js
    this.colorCodeInput = document.getElementById('selected-custom-color-code');
    if (!this.colorCodeInput) {
      this.colorCodeInput = document.createElement('input');
      this.colorCodeInput.type = 'hidden';
      this.colorCodeInput.id = 'selected-custom-color-code';
      this.colorCodeInput.name = 'properties[Color Code]';
      this.colorCodeInput.value = '';
      form.appendChild(this.colorCodeInput);
      console.log('[STANDARD-COLOR] Created Color Code input');
    }
  }

  checkCurrentVariant() {
    const currentVariantId = document.querySelector('input[name="id"]')?.value || 
                            document.querySelector('select[name="id"]')?.value;
    
    if (!currentVariantId) {
      console.log('[STANDARD-COLOR] No variant ID found');
      return;
    }

    // Check if "Custom Color" is selected - if so, don't interfere
    const selectedColorRadio = document.querySelector('input[type="radio"][name*="Color"]:checked');
    if (selectedColorRadio && selectedColorRadio.value === 'Custom Color') {
      console.log('[STANDARD-COLOR] Custom Color is selected - not interfering with custom color handler');
      return;
    }

    // Check if this variant has a color code metafield
    if (this.variantColorCodes[currentVariantId]) {
      const colorCode = this.variantColorCodes[currentVariantId];
      console.log('[STANDARD-COLOR] Variant', currentVariantId, 'has color code:', colorCode);
      
      // Only set the color code for standard colors
      if (this.colorCodeInput) {
        this.colorCodeInput.value = colorCode;
        console.log('[STANDARD-COLOR] Set Color Code:', colorCode);
      }
    } else {
      // Clear the color code if no metafield exists and it's not a custom color
      if (this.colorCodeInput) {
        this.colorCodeInput.value = '';
        console.log('[STANDARD-COLOR] Variant', currentVariantId, 'has no color code - cleared input');
      }
    }
  }

  listenForVariantChanges() {
    // Listen for Shopify variant change events
    document.addEventListener('variant:change', () => {
      console.log('[STANDARD-COLOR] Variant changed');
      this.checkCurrentVariant();
    });

    // Also listen for form changes
    const form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('change', (e) => {
        if (e.target.name === 'id' || (e.target.name && e.target.name.includes('Color'))) {
          setTimeout(() => this.checkCurrentVariant(), 100);
        }
      });
    }
  }
}

// Store class on window for duplicate check
window.StandardColorHandler = StandardColorHandler;

// Initialize when DOM is ready
if (!window.standardColorHandler) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (!window.standardColorHandler) {
        window.standardColorHandler = new StandardColorHandler();
      }
    });
  } else {
    window.standardColorHandler = new StandardColorHandler();
  }
}

} // End of duplicate check